import { render, staticRenderFns } from "./related-report.vue?vue&type=template&id=90b72454&scoped=true"
import script from "./related-report.vue?vue&type=script&lang=ts"
export * from "./related-report.vue?vue&type=script&lang=ts"
import style0 from "./related-report.vue?vue&type=style&index=0&id=90b72454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b72454",
  null
  
)

export default component.exports